import React from 'react';
import { Text, View, Page, Document, Image } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';

// Payment-specific styles matching payment.html
const styles = StyleSheet.create({
  page: {
    padding: 15,
    fontSize: 11,
    fontFamily: 'Helvetica',
    lineHeight: 1.3,
    color: '#333',
  },
  
  /* Header Section */
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 15,
    borderBottomWidth: 2,
    borderBottomColor: '#e5e7eb',
    paddingBottom: 10,
  },
  
  logoSection: {
    flex: 1,
  },
  
  companyLogo: {
    maxHeight: 50,
    width: 'auto',
  },
  
  companyName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  
  invoiceDetails: {
    textAlign: 'right',
    flex: 1,
  },
  
  invoiceTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 5,
  },
  
  invoiceNumber: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  invoiceDate: {
    fontSize: 11,
    color: '#6b7280',
  },
  
  statusBadge: {
    fontSize: 9,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: 5,
    padding: '3px 10px',
    borderRadius: 20,
  },
  
  statusConfirmed: {
    backgroundColor: '#e5e7eb',
    color: '#1f2937',
  },
  
  statusPending: {
    backgroundColor: '#f3f4f6',
    color: '#374151',
  },
  
  /* Company Information */
  companyInfo: {
    marginBottom: 15,
  },
  
  companyNameHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 3,
  },
  
  companyAddress: {
    fontSize: 10,
    color: '#6b7280',
    lineHeight: 1.4,
  },
  
  /* Billing Section */
  billingSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  
  billingInfo: {
    flex: 1,
    marginRight: 15,
  },
  
  serviceInfo: {
    flex: 1,
    marginLeft: 15,
  },
  
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 5,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  
  customerDetails: {
    backgroundColor: '#fafafa',
    padding: 10,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#4b5563',
  },
  
  customerName: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 3,
  },
  
  customerEmail: {
    fontSize: 11,
    color: '#6b7280',
  },
  
  serviceDetails: {
    backgroundColor: '#fafafa',
    padding: 10,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#4b5563',
  },
  
  serviceLevel: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  serviceCategory: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  flightRoute: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  flightNumber: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  departureDate: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  arrivalDate: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 3,
  },
  
  /* Items Section */
  itemsSection: {
    marginBottom: 15,
  },
  
  itemsTable: {
    width: '100%',
    marginTop: 8,
    borderCollapse: 'collapse',
  },
  
  tableHeader: {
    backgroundColor: '#fafafa',
    padding: 8,
    textAlign: 'left',
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    borderBottomWidth: 2,
    borderBottomColor: '#e5e7eb',
  },
  
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  
  tableCell: {
    padding: 8,
    fontSize: 11,
    flex: 1,
  },
  
  serviceDescription: {
    fontWeight: 'bold',
    color: '#1f2937',
  },
  
  serviceType: {
    color: '#6b7280',
    fontSize: 10,
  },
  
  amountCell: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  
  currencySymbol: {
    fontWeight: 'bold',
  },
  
  /* Price Breakdown Section */
  priceBreakdownSection: {
    marginTop: 15,
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#fafafa',
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#4b5563',
  },
  
  priceBreakdownTable: {
    width: '100%',
  },
  
  priceRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '5px 10px',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    fontSize: 11,
  },
  
  priceLabel: {
    textAlign: 'left',
    color: '#6b7280',
  },
  
  priceAmount: {
    textAlign: 'right',
    fontWeight: 'bold',
    color: '#1f2937',
  },
  
  subtotalRow: {
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold',
  },
  
  /* Totals Section */
  totalsSection: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  
  totalsTable: {
    width: 300,
  },
  
  totalRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '5px 10px',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    fontSize: 11,
  },
  
  totalLabel: {
    textAlign: 'left',
    color: '#6b7280',
  },
  
  totalAmount: {
    textAlign: 'right',
    fontWeight: 'bold',
    color: '#1f2937',
  },
  
  totalRowFinal: {
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold',
    fontSize: 13,
  },
  
  /* Footer */
  footer: {
    marginTop: 20,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    textAlign: 'center',
    color: '#6b7280',
    fontSize: 9,
  },
  
  footerText: {
    marginBottom: 5,
  },
  
  terms: {
    fontSize: 8,
    color: '#9ca3af',
    lineHeight: 1.3,
  },
});

const PaymentPDF = ({ booking }) => {
  // Calculate pricing
  const basePrice = parseFloat(booking.basePrice || booking.amount || booking.totalPrice || 50.00);
  const vatAmount = basePrice * 0.2;
  const totalAmount = basePrice + vatAmount;
  const additionalFees = booking.additionalFees || 0;
  const subtotal = basePrice + additionalFees;

  // Generate reference number
  const referenceNumber = booking._id ? `PAY-${booking._id.slice(-6).toUpperCase()}` : 'PAY-TBD';
  
  // Format dates
  const currentDate = new Date().toLocaleDateString();
  
  // Get service details
  const serviceType = booking.serviceType || 'VIP Service';
  const serviceLevel = booking.serviceLevel || 'Standard';
  const serviceCategory = booking.categoryName || 'Meet & Greet';
  
  // Get flight details
  const flightNumber = booking.flightNumber || 'TBD';
  const fromAirport = booking.from || 'TBD';
  const toAirport = booking.to || 'TBD';
  const flightRoute = `${fromAirport} to ${toAirport}`;
  const departureDate = booking.departureDate || booking.serviceDate || 'TBD';
  const arrivalDate = booking.arrivalDate || 'TBD';

  const formatCurrency = (value) => `${parseFloat(value).toFixed(2)}`;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        
        {/* Header Section */}
        <View style={styles.header}>
          <View style={styles.logoSection}>
            <Image 
              src="/airportpicture.jpg" 
              style={styles.companyLogo}
              alt="Company Logo"
            />
          </View>
          <View style={styles.invoiceDetails}>
            <Text style={styles.invoiceTitle}>PAYMENT INVOICE</Text>
            <Text style={styles.invoiceNumber}>Invoice #: {referenceNumber}</Text>
            <Text style={styles.invoiceDate}>Date: {currentDate}</Text>
            <Text style={[styles.statusBadge, styles.statusConfirmed]}>
              {booking.status || 'CONFIRMED'}
            </Text>
          </View>
        </View>
        
        {/* Company Information */}
        <View style={styles.companyInfo}>
          <Text style={styles.companyNameHeader}>Airport Meet & Greet Services</Text>
          <Text style={styles.companyAddress}>
            123 Airport Road, London, UK SW1A 1AA | Phone: +44 20 7123 4567 | Email: info@airportmeetgreet.com | VAT No: 177013321
          </Text>
        </View>
        
        {/* Billing Information */}
        <View style={styles.billingSection}>
          <View style={styles.billingInfo}>
            <Text style={styles.sectionTitle}>Bill To</Text>
            <View style={styles.customerDetails}>
              <Text style={styles.customerName}>{booking.clientName || 'Customer'}</Text>
              <Text style={styles.customerEmail}>{booking.clientEmail || 'customer@example.com'}</Text>
            </View>
          </View>
          <View style={styles.serviceInfo}>
            <Text style={styles.sectionTitle}>Service Information</Text>
            <View style={styles.serviceDetails}>
              <Text style={styles.serviceLevel}>Service Level: {serviceLevel}</Text>
              <Text style={styles.serviceCategory}>Service Category: {serviceCategory}</Text>
              <Text style={styles.flightRoute}>Flight Route: {flightRoute}</Text>
              <Text style={styles.flightNumber}>Flight Number: {flightNumber}</Text>
              <Text style={styles.departureDate}>Departure: {departureDate}</Text>
              <Text style={styles.arrivalDate}>Arrival: {arrivalDate}</Text>
            </View>
          </View>
        </View>
        
        {/* Payment Details */}
        <View style={styles.itemsSection}>
          <Text style={styles.sectionTitle}>Payment Details</Text>
          <View style={styles.itemsTable}>
            <View style={styles.tableRow}>
              <Text style={styles.tableHeader}>Description</Text>
              <Text style={styles.tableHeader}>Service Type</Text>
              <Text style={styles.tableHeader}>Amount</Text>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCell}>
                <Text style={styles.serviceDescription}>
                  {booking.description || `${serviceType} Service`}
                </Text>
              </View>
              <View style={styles.tableCell}>
                <Text style={styles.serviceType}>{serviceType}</Text>
              </View>
              <View style={[styles.tableCell, styles.amountCell]}>
                <Text>
                  <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                  {formatCurrency(totalAmount)}
                </Text>
              </View>
            </View>
          </View>
        </View>
        
        {/* Price Breakdown Section */}
        <View style={styles.priceBreakdownSection}>
          <Text style={styles.sectionTitle}>Price Breakdown</Text>
          <View style={styles.priceBreakdownTable}>
            <View style={styles.priceRow}>
              <Text style={styles.priceLabel}>{serviceLevel} Service (Base Price):</Text>
              <Text style={styles.priceAmount}>
                <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                {formatCurrency(basePrice)}
              </Text>
            </View>
            {additionalFees > 0 && (
              <View style={styles.priceRow}>
                <Text style={styles.priceLabel}>
                  Additional Services ({booking.baggageCount || 1} bags - {booking.baggageRange || 'standard'}):
                </Text>
                <Text style={styles.priceAmount}>
                  <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                  {formatCurrency(additionalFees)}
                </Text>
              </View>
            )}
            <View style={[styles.priceRow, styles.subtotalRow]}>
              <Text style={styles.priceLabel}>Subtotal:</Text>
              <Text style={styles.priceAmount}>
                <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                {formatCurrency(subtotal)}
              </Text>
            </View>
          </View>
        </View>
        
        {/* Totals Section */}
        <View style={styles.totalsSection}>
          <View style={styles.totalsTable}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Subtotal:</Text>
              <Text style={styles.totalAmount}>
                <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                {formatCurrency(subtotal)}
              </Text>
            </View>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>VAT (20%):</Text>
              <Text style={styles.totalAmount}>
                <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                {formatCurrency(vatAmount)}
              </Text>
            </View>
            <View style={[styles.totalRow, styles.totalRowFinal]}>
              <Text style={styles.totalLabel}>Total:</Text>
              <Text style={styles.totalAmount}>
                <Text style={styles.currencySymbol}>{booking.currency || '£'}</Text>
                {formatCurrency(totalAmount)}
              </Text>
            </View>
          </View>
        </View>
        
        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            Thank you for your payment! This invoice confirms your successful payment for the {serviceType} service.
          </Text>
          <Text style={styles.terms}>
            This is an automated payment confirmation invoice. For any questions regarding this payment, 
            please contact our customer service team at info@airportmeetgreet.com or call +44 20 7123 4567.
            Payment processed securely through Stripe. All amounts include applicable taxes.
          </Text>
        </View>
        
      </Page>
    </Document>
  );
};

export default PaymentPDF;